import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div
      className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center relative overflow-hidden"
      style={{ fontFamily: 'Montserrat, sans-serif' }}
    >
      {/* Ambient glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_#C9A84C05_0%,_transparent_70%)]" />

      {/* Ghost 404 */}
      <div
        className="absolute select-none pointer-events-none text-center leading-none"
        style={{
          fontFamily: 'Playfair Display, serif',
          fontSize: 'clamp(10rem, 32vw, 26rem)',
          fontWeight: 400,
          color: 'rgba(201,168,76,0.04)',
          letterSpacing: '-0.02em',
        }}
      >
        404
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 gap-7">
        {/* Label */}
        <div className="flex items-center gap-4">
          <div className="h-px w-8 bg-[#C9A84C]" />
          <span className="text-[#C9A84C] text-[10px] tracking-[4px] font-light">PAGE NOT FOUND</span>
          <div className="h-px w-8 bg-[#C9A84C]" />
        </div>

        {/* Headline */}
        <h1
          className="text-5xl sm:text-7xl text-[#F5F5F0] tracking-tight leading-tight"
          style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
        >
          Nothing Here
        </h1>

        <p className="text-[#F5F5F0]/35 text-sm tracking-wide leading-relaxed max-w-xs font-light">
          This page doesn&apos;t exist or may have moved.
          <br />
          Let&apos;s get you back to the music.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-2">
          <Link
            to="/"
            className="inline-flex items-center gap-3 px-8 py-4 border border-[#C9A84C] text-[#C9A84C] text-[11px] tracking-[2.5px] hover:bg-[#C9A84C] hover:text-[#0A0A0A] transition-all duration-300 cursor-pointer whitespace-nowrap group min-h-[48px]"
          >
            <i className="ri-arrow-left-line text-xs transition-transform duration-300 group-hover:-translate-x-1" />
            BACK HOME
          </Link>
          <Link
            to="/music"
            className="inline-flex items-center gap-3 px-8 py-4 border border-[#F5F5F0]/10 text-[#F5F5F0]/40 text-[11px] tracking-[2.5px] hover:border-[#C9A84C]/30 hover:text-[#F5F5F0] transition-all duration-300 cursor-pointer whitespace-nowrap min-h-[48px]"
          >
            EXPLORE MUSIC
            <i className="ri-music-2-line text-xs" />
          </Link>
        </div>

        {/* Brand watermark */}
        <p className="text-[#F5F5F0]/12 text-[9px] tracking-[3px] mt-3">
          KEN ONLYY &nbsp;&middot;&nbsp; ROSE GOLD RECORDS
        </p>
      </div>
    </div>
  );
}
